import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import PageLayout from "@/components/PageLayout";
import { videos } from "@/data/mockData";

const VideoDetail = () => {
  const { id } = useParams();
  const video = videos.find((v) => v.id === id);

  if (!video) {
    return (
      <PageLayout>
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-foreground">Video not found</h1>
          <Link to="/videos" className="text-muted-foreground hover:text-foreground mt-4 inline-block">← Back to Videos</Link>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto">
        <Link to="/videos" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Videos
        </Link>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="aspect-video w-full rounded-lg overflow-hidden bg-secondary mb-8 relative"
        >
          <img src={video.image} alt={video.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-background/40 flex items-center justify-center">
            <p className="text-foreground text-sm bg-background/60 backdrop-blur-sm px-4 py-2 rounded-full">
              Video player placeholder
            </p>
          </div>
        </motion.div>

        <h1 className="text-3xl font-bold text-foreground mb-2">{video.title}</h1>
        <div className="flex flex-wrap items-center gap-4 text-muted-foreground text-sm mb-6">
          <span>{video.type}</span>
          <span>·</span>
          <span>{video.duration}</span>
          <span>·</span>
          <span>{video.date}</span>
          {video.director && (
            <>
              <span>·</span>
              <span>Dir. {video.director}</span>
            </>
          )}
        </div>
        <p className="text-muted-foreground leading-relaxed">{video.description}</p>
      </div>
    </PageLayout>
  );
};

export default VideoDetail;
